import { Box, Flex, Typography } from '@iheartjane/reefer';
import { dedupeDispensary } from '@iheartjane/utils';
import Mustache from 'mustache';

import { us_states_map } from '@jane/shared/util';

const safeMustacheRender = (
  template: string,
  variables: Record<string, unknown>
): string => {
  try {
    return Mustache.render(
      template,
      variables,
      {},
      { escape: (text: string) => text }
    );
  } catch {
    return template;
  }
};

const PreviewSeo = ({
  menuUrl,
  title,
  description,
  variables,
}: {
  description?: string;
  menuUrl?: string;
  title?: string;
  variables: Record<string, unknown>;
}) => {
  const seoVariables = {
    ...variables,
    storeStateAbbr: us_states_map[variables['storeStateAbbr'] as string],
  };

  return (
    <>
      <Flex
        flexDirection="column"
        background="grays-ultralight"
        p={40}
        mt={40}
        mx={-40}
      >
        <Typography color="grays-mid" variant="body-bold">
          Preview
        </Typography>
        <Box
          background="grays-white"
          p={24}
          mt={8}
          borderRadius="xs"
          border="grays-light"
        >
          <Flex alignItems="center">
            <Typography color="grays-mid" mr={8}>
              {menuUrl?.replace(/ /g, '-').toLowerCase()}
            </Typography>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="2"
              height="10"
              viewBox="0 0 2 10"
              fill="none"
            >
              <path
                d="M2 1C1.99996 1.55221 1.55219 2 1 2C0.447865 1.99993 4.22001e-05 1.55216 0 1C0 0.447799 0.447839 6.59332e-05 1 -4.37114e-08C1.55222 -1.95732e-08 2 0.447758 2 1ZM2 4.99902C1.99995 5.55122 1.55218 5.99902 1 5.99902C0.447871 5.99896 5.26905e-05 5.55118 0 4.99902C0 4.44682 0.447839 3.99909 1 3.99902C1.55222 3.99902 2 4.44678 2 4.99902ZM2 8.99902C2 9.55126 1.55222 9.99902 1 9.99902C0.447839 9.99896 0 9.55122 0 8.99902C4.23193e-05 8.44686 0.447865 7.99909 1 7.99902C1.55219 7.99902 1.99996 8.44682 2 8.99902Z"
                fill="#666666"
              />
            </svg>
          </Flex>
          <Typography color="purple-dark" variant="header" my={12}>
            {dedupeDispensary(safeMustacheRender(title ?? '', seoVariables))}
          </Typography>
          <Typography color="grays-dark">
            {dedupeDispensary(
              safeMustacheRender(description ?? '', seoVariables)
            )}
          </Typography>
        </Box>
      </Flex>
    </>
  );
};

export default PreviewSeo;
